import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class MachineDeleteNodeFromSidePanelHandler {
  deleteNodeFromSidePanel(nodeId: string) {
    const initialStructureNodeset = getInitialStructureNodeset();
    const machineStructureNodeset = getMachineStructureNodeset();

    // we check here if the root node is loaded yet (initial structure might still be loading)
    // if it is, we set the transferred attribute to false for all selected nodes in the initial structure nodeset
    // because they are being deleted from the machine structure nodeset and should not be transferred to the machine structure on save
    if (initialStructureNodeset.getRootNode()) {
      initialStructureNodeset.setTransferredAttributeOnSelectedNodes(
        false,
        new Set([nodeId]),
      );
      initialStructureNodeset.setFlatMap(
        initialStructureNodeset.getRootNode().createMapFromOurNodeTree(),
      );
    }

    const flatMap = machineStructureNodeset.getFlatMap();

    const nodeToBeDeleted = flatMap.get(nodeId);

    machineStructureNodeset.deleteNodesInSidePanel(nodeToBeDeleted);
  }
}
